<script setup lang="ts"></script>

<template>
  <h4 class="card-subtitle mb-3 text-primary-emphasis">
    <slot />
  </h4>
</template>

<style scoped>
h4.card-subtitle {
  font-size: 16px;
  font-style: italic;
}
</style>
